import { gql } from "@/services/httpAdapter";

export const onCreateNotificationSubscription = gql`
	subscription onCreateNotification($userId: String) {
		onCreateNotification(userId: $userId) {
			_id
			createdAt
			createdBy
			message
			newNotification
			read
			userId
			topic
		}
	}
`;
export const onUpdateNewNotificationSubscription = gql`
	subscription onUpdateNewNotification($userId: String) {
		onUpdateNewNotification(userId: $userId) {
			userId
		}
	}
`;
export const onUpdateNotificationSubscription = gql`
	subscription onUpdateNotification($userId: String) {
		onUpdateNotification(userId: $userId) {
			_id
			createdAt
			createdBy
			message
			newNotification
			read
			userId
			topic
		}
	}
`;
